import type { IWhereUsedSectionTab } from '~/components/pages/directions/where-used-section/where-used-section.types'

const WHERE_USED_AUDIOGUIDE: IWhereUsedSectionTab[] = [
    {
        title: 'Музеи и выставки',
        image: '/assets/images/usage/audioguide/jpg-png/in-museum.jpg',
        image_webp: '/assets/images/usage/audioguide/webp/in-museum.webp',
        text: `
            <p>Автоматизация групповых и&nbsp;индивидуальных экскурсий без участия экскурсовода.</p>
            <p>Слушать можно в&nbsp;наушниках, либо через динамик.</p>
            <p>А&nbsp;если использовать мастер-гид A-1&nbsp;Pro, то&nbsp;можно вручную управлять группой аудиогидов, запускаю треки в&nbsp;нужное время. При этом каждый посетитель остается независимым, поскольку может отключить эту экскурсию или запустить её&nbsp;заново.</p>
            <br/>
            <p>Благодаря высококачественной студийной записи диктора, его голос будет отчетливо слышен в&nbsp;персональных наушниках.</p>
            <p>Поможем с&nbsp;организацией записи контента на&nbsp;профессиональной студии с&nbsp;диктором.</p>
            `,
    },
    {
        title: 'Пешие экскурсии',
        image: '/assets/images/usage/audioguide/jpg-png/sight.png',
        image_webp: '/assets/images/usage/audioguide/webp/sight.webp',
        text: `
            <p>Не&nbsp;нужно нанимать гида для экскурсий.</p>
            <p>Сопровождающий управляет запуском треков со&nbsp;своего мастер-гида.</p>
            <p>Турист может сам выбрать язык и&nbsp;громкость.</p>
            <p>Так&nbsp;же можно настроить включение аудиотреков в&nbsp;зависимости от&nbsp;GPS-координат.</p>
            `,
    },
    {
        title: 'На производстве',
        image: '/assets/images/usage/audioguide/jpg-png/production.png',
        image_webp: '/assets/images/usage/audioguide/webp/production.webp',
        text: `
            <p>Аудиогиды позволяют проводить экскурсии и&nbsp;лекции на&nbsp;заводе, фабрике или в&nbsp;любом самом шумном цеху благодаря чёткой дикторской записи и&nbsp;использованию стереонаушников. Наушники могут быть как многоразовыми, так и&nbsp;одноразовыми.</p>
            <p>Наши аудиогиды часто используют не&nbsp;только для потенциальных клиентов производственных компаний, но&nbsp;и&nbsp;для новых сотрудников, которым необходимо пройти обучение в&nbsp;условиях повышенного шума (для примера, Автозавод &laquo;Москвич&raquo;).</p>
            <p>А&nbsp;если разместить на&nbsp;нужных точках цеха маячки &laquo;M-1&raquo;, то&nbsp;процесс может проходить в&nbsp;полностью автоматическом режиме, что сильно экономить ресурс управляющего персонала.</p>
            `,
    },
    {
        title: 'Речные круизы',
        image: '/assets/images/usage/audioguide/jpg-png/boat-group-tour.png',
        image_webp: '/assets/images/usage/audioguide/webp/boat-group-tour.webp',
        text: `
            <p>Шум ветра на&nbsp;воде и&nbsp;гул двигателя больше не&nbsp;будут проблемой благодаря экскурсионным аудиогидам SPBAUDIO.</p>
            <p>Полная автоматизация экскурсий для постоянного потока пассажиров сильно экономит ресурс компании.</p>
            <p>Турист может сам выбрать язык и&nbsp;громкость.</p>
            <p>Так&nbsp;же можно настроить включение аудиотреков в&nbsp;зависимости от&nbsp;GPS-координат.</p>
            <p>Индивидуальная разработка и&nbsp;адаптация для крупных туристических и&nbsp;экскурсионных компаний.</p>
            `,
    },
    {
        title: 'Автобусные туры',
        image: '/assets/images/usage/audioguide/jpg-png/bus-tour.png',
        image_webp: '/assets/images/usage/audioguide/webp/bus-tour.webp',
        text: `
            <p>Шум дороги и&nbsp;соседей, а&nbsp;так&nbsp;же гул двигателя больше не&nbsp;будут проблемой благодаря экскурсионным аудиогидам SPBAUDIO.</p>
            <p>Полная автоматизация экскурсий для постоянного потока пассажиров сильно экономит ресурс компании.</p>
            <p>Турист может сам выбрать язык и&nbsp;громкость.</p>
            <p>Так&nbsp;же можно настроить включение аудиотреков в&nbsp;зависимости от&nbsp;GPS-координат.</p>
            <p>Индивидуальная разработка и&nbsp;адаптация для крупных туристических и&nbsp;экскурсионных компаний.</p>
            `,
    },
]

export default WHERE_USED_AUDIOGUIDE
